import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
const DEVICE_ID_COOKIE = 'amp_device_id';
const SESSION_ID_COOKIE = 'amp_session_id';
let stateIdCookieHandling;
export const getStoredCookies = props => {
  try {
    stateIdCookieHandling = props.stateIdCookieHandling;
    return stateIdCookieHandling ? {
      deviceId: __getCookieDeviceId(props, cookieHandler()),
      sessionId: __getCookieSessionId(props, cookieHandler())
    } : props;
  } catch (e) {
    console.error(e);
  }
  return {
    deviceId: uuidv4()
  };
};
export const __getCookieDeviceId = (props, cookieHandler) => {
  const deviceId = props.deviceId || cookieHandler.get(DEVICE_ID_COOKIE) || uuidv4();
  __setDeviceId(deviceId, cookieHandler);
  return deviceId;
};
export const setDeviceId = deviceId => {
  try {
    __setDeviceId(deviceId, cookieHandler());
  } catch (e) {
    console.error(e);
  }
};
export const __setDeviceId = (deviceId, cookieHandler) => {
  if (stateIdCookieHandling) {
    cookieHandler.set(DEVICE_ID_COOKIE, deviceId, 365);
  }
};
export const __getCookieSessionId = (props, cookieHandler) => {
  const sessionId = props.sessionId || Number(cookieHandler.get(SESSION_ID_COOKIE)) || Date.now();
  __setSessionId(sessionId, cookieHandler);
  return sessionId;
};
export const setSessionId = sessionId => {
  try {
    __setSessionId(sessionId, cookieHandler());
  } catch (e) {
    console.error(e);
  }
};
const sessionExpiryIn30Minutes = 1 / 48;
export const __setSessionId = (sessionId, cookieHandler) => {
  if (stateIdCookieHandling) {
    cookieHandler.set(SESSION_ID_COOKIE, sessionId === null || sessionId === void 0 ? void 0 : sessionId.toString(), sessionExpiryIn30Minutes);
  }
};
export const __getCookieDomain = hostname => {
  if (hostname !== null && hostname !== void 0 && hostname.includes('.fanduel.com')) return '.fanduel.com';
  if (hostname !== null && hostname !== void 0 && hostname.includes('.fanduel.ca')) return '.fanduel.ca';
  if (hostname !== null && hostname !== void 0 && hostname.includes('.fndl.dev')) return '.fndl.dev';
  if (hostname !== null && hostname !== void 0 && hostname.includes('.fdbox.net')) return '.fdbox.net';
  return undefined;
};
const cookieHandler = () => {
  function set(name, value, expiryDays) {
    var _document;
    Cookies.set(name, value, {
      expires: expiryDays,
      domain: __getCookieDomain((_document = document) === null || _document === void 0 || (_document = _document.location) === null || _document === void 0 ? void 0 : _document.hostname),
      path: '/'
    });
  }
  return {
    get: Cookies.get,
    set
  };
};
//# sourceMappingURL=cookies.js.map